import store from './index.js';
export function setGUID(){
	try{
		let guid=store.getters.GUID;
		if(!guid||guid==''){
			store.commit('setGUID')
		}
	}catch(e){
		console.log(e)
		window.BH.message(e);
	}
}
export function LogIn(){
	let userinfo=store.getters.UserInfo;
	// console.log(userinfo)
	return userinfo._logIn
}
export function printset(){
	let userinfo=store.getters.UserInfo;
	// console.log(userinfo)
	return userinfo._printset;
}
//校验token退出登录
export function logout(callback){
	return store.commit('logout',callback);
}
export function Stoken(){
	// console.log(store.getters.Stoken);
	return store.getters.Stoken;
}
export function _Stoken(){
	// console.log(store.getters.Stoken);
	return store.getters.refreshStoken;
}
export function setInservet(){
	return store.commit('setSerInvrtCheck')
}
export function stopInterval(){
	return store.commit('StopInterval')
}
export function Interval(){
	return store.state.serServlet;
}
export function IsLogin(){
	return store.getters.IsLogin;
}
export function refreshaccessToken(str,name){
	// console.log(store.getters.UserInfo.username.toLowerCase(),name.toLowerCase())
	//需要区分大小写
	console.log('refreshToken')
	try{
		console.log(str,name,store.getters.UserName)
		if(store.getters.UserName.toLowerCase()==name.toLowerCase())
			return store.commit('setStoken',str);
		else{
			window.BH.message('Token不正确,不属于当前用户，请重新登录');
			store.commit('logout');
			// return new Promise((resolve,reject)=>{
				
			// 	console.log('Token不正确')
			// 	reject();
			// }) 
		}
	}catch(e){
		window.BH.message(e);
	}
	
}
export const IsCGY=store&&store.state.userinfo&&store.state.userinfo.accountType=='cgy';//当前登录的用户信息
